// extracted by mini-css-extract-plugin
export var calendarView = "_ol-0";
export var dayButton = "_ol-1";
export var dayCircle = "_ol-2";